import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { finSobPlanningValidationRules } from 'partner360/configs/p360Checks/finSobPlanningValidationRules'
import { ICompletenessInfo } from 'partner360/entities/partnerCompleteness'

import { IFinSobValidationGroup } from './models/IFinSobCheckItem'

// Categories tags
export const PLAN_SECTION_KEY = 'jbp-planning'
export const OVERALL_CATEGORY = 'jbp-overall'
export const PLANNING_TOTAL_CATEGORY = 'jbp-planning-total'
export const PLANNING_MIF_CATEGORY = 'jbp-planning-mif-replacement'
export const GLOBAL_TOTAL_CATEGORY = 'jbp-total'
export const BPS_CATEGORY_NOT_APPLICABLE_STATE = 'jbp-pc-bps-na'
export const PLANNING_SUBSCRIPTION_CATEGORY = 'jbp-mps-subscription'

// Partners and Settings flags
export const CONTRACTUAL_FLAGS = 'IsMPS'
// export const CONTRACTUAL_FLAGS_QBR = 'IsMPS,IsPrintServices'
export const CONTRACTUAL_CATEGORY = 'jbp-print-officehw'
// export const READONLY_FLAGS_QBR = 'IsOPSTopPartner,IsBPSTopPartner'
export const CORE_TOP_PARTNER_FLAGS = 'IsOPSTopPartner'
export const PS_TOP_PARTNER_FLAGS = 'IsBPSTopPartner'
export const IS_TOP_OPS_FLAG = 'IsOPSTopPartner'
export const OFFICE_HW_CATEGORY = 'jbp-print-officehw'
export const LASER_PRINT_SUB_CATEGORY = 'jbp-print-officehw-laserprinter'
export const AIPC_CATEGORY = 'jbp-pc-aipc'
export const ROOM_CATEGORY = 'jbp-pc-room'
export const POLY_CATEGORY = 'jbp-pc-poly'
export const POLY_SUB_CATEGORIES = ['jbp-pc-poly-video', 'jbp-pc-poly-voice', 'jbp-pc-poly-headset']
export const SOB_DETAILS_MANDATORY_CATEGORIES = [POLY_CATEGORY, ROOM_CATEGORY]
export const SOB_DETAILS_MANDATORY_OFFERINGS = [ProgramTypes.Retail]

export const IS_SHOW_PREV_PREV_FYEAR = true

// Fields
export const COMPLETENESS_INFO_FIN_SOB_PLAN_FIELD: keyof ICompletenessInfo = 'FinSobPlan'
export const COMPOSED_PARTNER_ID = 'PartnerID'

export enum PlanningRounding {
  AsIs = 'AsIs',
  K = 'K',
  M = 'M',
}
export const ROUNDING_VALUES = [PlanningRounding.AsIs, PlanningRounding.K, PlanningRounding.M]
export const DISPLAY_OPTIONS = ['Flat', 'Hierarchical']

// Hide Not Applicable switcher for Category
export const MANDATORY_CATEGORY = 1
// Hide Not Applicable switcher, hide Collapse mode and always Expand Category
export const MANDATORY_CATEGORY_ALWAYS_EXPANDED = 2

export const PLANNING_URL_DEPS = ['pid', 'jbp-tab', 'hr-tab']

export const PLAN_SHOW_FOR_PREV_YEARS = 1
// +1 for calc Grow
export const PLAN_REQUEST_FOR_PREV_YEARS = PLAN_SHOW_FOR_PREV_YEARS + 1
export const P360_FIRST_FYEAR = 2019
// Apply SST Mandatory logic on planning section (Strategic Service Partner)
export const SST_MANDATORY_LOGIC_FYEAR = 2024
export const SOB_NEW_LOGIC_FYEAR = 2024

export const IS_RECALC_SOB = true
export const IS_ALWAYS_SHOW_ACTUALS = true
export const IS_ALWAYS_SHOW_SOB = true
export const IS_QUARTER_DEFAULT = true
export const IS_HIDE_QUOTA_GROW = false
export const IS_BEVEL_ENABLED = false
export const IS_USE_LEVEL_ICON = false
export const IS_SHOW_NULL = true
export const IS_SHOW_INFORMATION_BANNERS = false
export const IS_SHOW_PARTNERS_COMPLETENESS_FOR_ALL_ROWS = true
export const IS_SHOW_PARTNERS_COMPLETENESS_FOR_SUB_CATEGORIES = false
export const IS_SHOW_PARTNERS_COMPLETENESS_FOR_CONTRACTUAL_PLAN = false
export const IS_SHOW_COMPOSED_REPORT_EXPANDED_WARNING = false
export const IS_USE_RECALC_PLANS_FROM_BOTTOM_FUNCTIONALITY = false
export const IS_SHOW_PREV_RECALC_ACTUALS = true
export const IS_SHOW_NOT_APPLICABLE = false
export const IS_SHOW_RETAIL_GTM_PRIORITIES = false

export const PLANNING_COLUMN_COLORS = {
  financial: {
    quarter: '#f0f9f8',
    year: '#ffe8e8',
  },
  sob: {
    quarter: '#e5f4f2',
    year: '#ffdddd',
  },
} as const

export const IS_NEW_LNF = true

export const HIDE_SOB_FOR_COUNTRY = 'JP'
export const HIDE_TNET_DISCLAIMER_FOR_COUNTRY = 'JP'
export const SOB_FRACTION_DIGITS = 1
export const MAP_FRACTION_DIGITS = 1

export const PERCENT_FRACTION_DIGITS = 1

export const SOB_STATE_FIELD = 'SOBState'
export const PLAN_STATE_FIELD = 'PlanState'
export const FIELD_STATE_DISABLED = -1
export const FIELD_STATE_HIGHLIGHT = 1

export const FIN_FRACTION_DIGITS = 0
export const FIN_FRACTION_DIGITS_ROUNDING = 2

export const EMPTY_MAP_PLACEHOLDER = '-'

export const PLANNING_COL_NUMBER = 1 + 2 + 2 + 4 * 3
export const PLANNING_BY_FY_FQ = 5
export const IS_CALC_FY_SOB_BY_ALL_FQ = true

export const FYEAR_OFFSETS = [0, 1, 2] // Current, Next, Next+2
export const F_QUARTERS_ONLY = [1, 2, 3, 4] // Quarters only
export const F_QUARTERS_FULL = [1, 2, 3, 4, PLANNING_BY_FY_FQ] // +FY

export const SHOW_YEARS_ON_GRAPHS = 5

export const actualsColor = '#217fc3' // Actuals color (blue, HUE 205°)
export const actualsDirectColor = '#21a7c3' // Actuals Direct color (cyan, HUE 190° = 205° - 15°)
export const actualsIndirectColor = '#2157c3' // Actuals Indirect color (indigo, HUE 220° = 205° + 15°)
//export const plannedColor = '#fc1a1a' // red
//export const plannedColor2 = '#ff9999' // red pale
export const targetsColor = '2c3038'
export const quotaColor = '#8a1ba1' // Quota violet (violet)
//export const trendColor = '#000000'

export const IS_ENABLE_ROUNDING = true

export const TARGETS_TOO_LOW_MESSAGE =
  "The targets you've filled in are too low in comparison with partner's actuals. Keep in mind that you must fill in targets in $, not in K$. Do you confirm that the targets are correct?"

export const finSobValidationGroups: IFinSobValidationGroup[] = [
  {
    // Check SOB Actuals
    key: 'jbp-planning-check-sob-actuals',
    rules: [...finSobPlanningValidationRules],
  },
  {
    // Check SOB Plan
    key: 'jbp-planning-check-sob-plan',
    rules: [
      {
        // Compare SoB Plan with prev FQ (same or Prev FY) SoB Plan
        key: 'jbp-planning-check-sob-plan-prev-fq',
        order: 1,
        isEnabled: true,
        current: { value: 'sob', type: 'targets' },
        compareTo: { value: 'sob', type: 'targets', fq: 'prev' },
        thresholds: { warning: 5, error: 10 },
      },
      {
        // Compare SoB Plan with prev FY (same FQ) SoB Plan
        key: 'jbp-planning-check-sob-plan-prev-fy',
        order: 2,
        isEnabled: true,
        current: { value: 'sob', type: 'targets' },
        compareTo: { value: 'sob', type: 'targets', fy: 'prev' },
        thresholds: { warning: 5, error: 10 },
      },
      {
        // Compare SoB Plan with (same FQ, same FY) SoB Actual
        key: 'jbp-planning-check-sob-plan-with-actuals',
        order: 3,
        isEnabled: true,
        current: { value: 'sob', type: 'targets' },
        compareTo: { value: 'sob', type: 'actuals' },
        thresholds: { warning: 5, error: 10 },
      },
    ],
  },
  {
    // Financial Data check
    // 1. Compare Fin Plan with the same quarter of the previous year actuals.
    // 2. TODO: The average quarterly actuals from the previous year.
    //
    // Validation Rules by Partner Type
    // Thresholds for Simple Confirmation and Justification
    key: 'jbp-planning-check-fin-plan-prev-fy-same-fq-actuals',
    rules: [
      {
        // Power Elite / Global Elite
        //
        key: 'jbp-planning-check-fin-plan-prev-fy-same-fq-actuals-elite',
        order: 1,
        isEnabled: true,
        partnerFlags: { include: ['PowerElite', 'PowerEliteGlobal'], exclude: ['Power'] },
        current: { value: 'fin', type: 'targets' },
        compareTo: { value: 'fin', type: 'actuals', fy: 'prev' },
        thresholds: { warning: 10, error: 20 },
        //options: { lastPrevVsFuture: true },
      },
      {
        // Power
        //
        // Compare Fin Plan with prev FY (same FQ) Fin Plan
        key: 'jbp-planning-check-fin-plan-prev-fy-same-fq-actuals-power',
        order: 2,
        isEnabled: true,
        partnerFlags: { include: ['Power'], exclude: ['PowerElite', 'PowerEliteGlobal'] },
        current: { value: 'fin', type: 'targets' },
        compareTo: { value: 'fin', type: 'actuals', fy: 'prev' },
        thresholds: { warning: 20, error: 30 },
        //options: { lastPrevVsFuture: true },
      },
      {
        // Other Partners
        //
        // If the increase exceeds 10x (1000%), request for justification.
        // Compare Fin Plan with prev FY (same FQ) Fin Plan
        key: 'jbp-planning-check-fin-plan-prev-fy-same-fq-actuals-other',
        order: 3,
        isEnabled: true,
        partnerFlags: { include: [], exclude: ['Power', 'PowerElite', 'PowerEliteGlobal'] },
        current: { value: 'fin', type: 'targets' },
        compareTo: { value: 'fin', type: 'actuals', fy: 'prev' },
        // TODO: Only check for increases.
        thresholds: { warning: NaN, error: 1000, reduction: 'increase' },
        //options: { lastPrevVsFuture: true },
      },
      {
        key: 'jbp-planning-check-fin-plan-prev-fy-average-fq-actuals-elite',
        order: 4,
        isEnabled: true,
        partnerFlags: { include: ['PowerElite', 'PowerEliteGlobal'], exclude: ['Power'] },
        current: { value: 'fin', type: 'targets' },
        compareTo: { value: 'fin', type: 'actuals', fy: 'prev', fq: 'average' },
        thresholds: { warning: 10, error: 20 },
      },
      {
        key: 'jbp-planning-check-fin-plan-prev-fy-average-fq-actuals-power',
        order: 5,
        isEnabled: true,
        partnerFlags: { include: ['Power'], exclude: ['PowerElite', 'PowerEliteGlobal'] },
        current: { value: 'fin', type: 'targets' },
        compareTo: { value: 'fin', type: 'actuals', fy: 'prev', fq: 'average' },
        thresholds: { warning: 20, error: 30 },
      },
      {
        key: 'jbp-planning-check-fin-plan-prev-fy-average-fq-actuals-other',
        order: 6,
        isEnabled: true,
        partnerFlags: { include: [], exclude: ['Power', 'PowerElite', 'PowerEliteGlobal'] },
        current: { value: 'fin', type: 'targets' },
        compareTo: { value: 'fin', type: 'actuals', fy: 'prev', fq: 'average' },
        thresholds: { warning: NaN, error: 1000, reduction: 'increase' },
      },
    ],
  },
  {
    // Financial Data check
    // 1. Compare Fin Plan with the same quarter of the previous year actuals.
    // 2. TODO: The average quarterly actuals from the previous year.
    //
    // Validation Rules by Partner Type
    // Thresholds for Simple Confirmation and Justification
    key: 'jbp-planning-check-fin-plan-prev-fy-same-fq-plan',
    rules: [
      {
        // Power Elite / Global Elite
        //
        key: 'jbp-planning-check-fin-plan-prev-fy-same-fq-plan-elite',
        order: 1,
        isEnabled: true,
        partnerFlags: { include: ['PowerElite', 'PowerEliteGlobal'], exclude: ['Power'] },
        current: { value: 'fin', type: 'targets' },
        compareTo: { value: 'fin', type: 'targets', fy: 'prev' },
        thresholds: { warning: 10, error: 20 },
        options: { isFutureOnly: true },
      },
      {
        // Power
        //
        // Compare Fin Plan with prev FY (same FQ) Fin Plan
        key: 'jbp-planning-check-fin-plan-prev-fy-same-fq-plan-power',
        order: 2,
        isEnabled: true,
        partnerFlags: { include: ['Power'], exclude: ['PowerElite', 'PowerEliteGlobal'] },
        current: { value: 'fin', type: 'targets' },
        compareTo: { value: 'fin', type: 'targets', fy: 'prev' },
        thresholds: { warning: 20, error: 30 },
        options: { isFutureOnly: true },
      },
      {
        // Other Partners
        //
        // If the increase exceeds 10x (1000%), request for justification.
        // Compare Fin Plan with prev FY (same FQ) Fin Plan
        key: 'jbp-planning-check-fin-plan-prev-fy-same-fq-plan-other',
        order: 3,
        isEnabled: true,
        partnerFlags: { include: [], exclude: ['Power', 'PowerElite', 'PowerEliteGlobal'] },
        current: { value: 'fin', type: 'targets' },
        compareTo: { value: 'fin', type: 'targets', fy: 'prev' },
        // TODO: Only check for increases.
        thresholds: { warning: NaN, error: 1000, reduction: 'increase' },
        options: { isFutureOnly: true },
      },
    ],
  },
  {
    // Units checks, similar to Financial checks, but may differ in the future
    //
    // Validation Rules by Partner Type
    // Thresholds for Simple Confirmation and Justification
    key: 'jbp-planning-check-units-plan-prev-fy-same-fq-actuals',
    rules: [
      {
        // Power Elite / Global Elite
        key: 'jbp-planning-check-units-plan-prev-fy-same-fq-actuals-elite',
        order: 1,
        isEnabled: true,
        partnerFlags: { include: ['PowerElite', 'PowerEliteGlobal'], exclude: ['Power'] },
        current: { value: 'units', type: 'targets' },
        compareTo: { value: 'units', type: 'actuals', fy: 'prev' },
        thresholds: { warning: 10, error: 20 },
        //options: { lastPrevVsFuture: true },
      },
      {
        // Power
        // Compare Units Plan with prev FY (same FQ) Units Plan
        key: 'jbp-planning-check-units-plan-prev-fy-same-fq-actuals-power',
        order: 2,
        isEnabled: true,
        partnerFlags: { include: ['Power'], exclude: ['PowerElite', 'PowerEliteGlobal'] },
        current: { value: 'units', type: 'targets' },
        compareTo: { value: 'units', type: 'actuals', fy: 'prev' },
        thresholds: { warning: 20, error: 30 },
        //options: { lastPrevVsFuture: true },
      },
      {
        // Other Partners
        // If the increase exceeds 10x (1000%), request for justification.
        // Compare Units Plan with prev FY (same FQ) Units Plan
        key: 'jbp-planning-check-units-plan-prev-fy-same-fq-actuals-other',
        order: 3,
        isEnabled: true,
        partnerFlags: { include: [], exclude: ['Power', 'PowerElite', 'PowerEliteGlobal'] },
        current: { value: 'units', type: 'targets' },
        compareTo: { value: 'units', type: 'actuals', fy: 'prev' },
        // TODO: Only check for increases.
        thresholds: { warning: NaN, error: 1000, reduction: 'increase' },
        //options: { lastPrevVsFuture: true },
      },
      {
        key: 'jbp-planning-check-units-plan-prev-fy-average-fq-actuals-elite',
        order: 4,
        isEnabled: true,
        partnerFlags: { include: ['PowerElite', 'PowerEliteGlobal'], exclude: ['Power'] },
        current: { value: 'units', type: 'targets' },
        compareTo: { value: 'units', type: 'actuals', fy: 'prev', fq: 'average' },
        thresholds: { warning: 10, error: 20 },
      },
      {
        key: 'jbp-planning-check-units-plan-prev-fy-average-fq-actuals-power',
        order: 5,
        isEnabled: true,
        partnerFlags: { include: ['Power'], exclude: ['PowerElite', 'PowerEliteGlobal'] },
        current: { value: 'units', type: 'targets' },
        compareTo: { value: 'units', type: 'actuals', fy: 'prev', fq: 'average' },
        thresholds: { warning: 20, error: 30 },
      },
      {
        key: 'jbp-planning-check-units-plan-prev-fy-average-fq-actuals-other',
        order: 6,
        isEnabled: true,
        partnerFlags: { include: [], exclude: ['Power', 'PowerElite', 'PowerEliteGlobal'] },
        current: { value: 'units', type: 'targets' },
        compareTo: { value: 'units', type: 'actuals', fy: 'prev', fq: 'average' },
        thresholds: { warning: NaN, error: 1000, reduction: 'increase' },
      },
    ],
  },
  {
    // Units checks, similar to Financial checks, but may differ in the future
    //
    // Validation Rules by Partner Type
    // Thresholds for Simple Confirmation and Justification
    key: 'jbp-planning-check-units-plan-prev-fy-same-fq-plan',
    rules: [
      {
        // Power Elite / Global Elite
        key: 'jbp-planning-check-units-plan-prev-fy-same-fq-plan-elite',
        order: 1,
        isEnabled: true,
        partnerFlags: { include: ['PowerElite', 'PowerEliteGlobal'], exclude: ['Power'] },
        current: { value: 'units', type: 'targets' },
        compareTo: { value: 'units', type: 'targets', fy: 'prev' },
        thresholds: { warning: 10, error: 20 },
        options: { isFutureOnly: true },
      },
      {
        // Power
        // Compare Units Plan with prev FY (same FQ) Units Plan
        key: 'jbp-planning-check-units-plan-prev-fy-same-fq-plan-power',
        order: 2,
        isEnabled: true,
        partnerFlags: { include: ['Power'], exclude: ['PowerElite', 'PowerEliteGlobal'] },
        current: { value: 'units', type: 'targets' },
        compareTo: { value: 'units', type: 'targets', fy: 'prev' },
        thresholds: { warning: 20, error: 30 },
        options: { isFutureOnly: true },
      },
      {
        // Other Partners
        // If the increase exceeds 10x (1000%), request for justification.
        // Compare Units Plan with prev FY (same FQ) Units Plan
        key: 'jbp-planning-check-units-plan-prev-fy-same-fq-plan-other',
        order: 3,
        isEnabled: true,
        partnerFlags: { include: [], exclude: ['Power', 'PowerElite', 'PowerEliteGlobal'] },
        current: { value: 'units', type: 'targets' },
        compareTo: { value: 'units', type: 'targets', fy: 'prev' },
        // TODO: Only check for increases.
        thresholds: { warning: NaN, error: 1000, reduction: 'increase' },
        options: { isFutureOnly: true },
      },
    ],
  },
  {
    // Distributor Planner has Total/Power/Non-Power split
    // Financial Data check
    key: 'jbp-planning-check-fin-plan-split',
    rules: [
      {
        key: 'jbp-planning-check-fin-plan-split-total',
        order: 1,
        isEnabled: true,
        current: { value: 'fin', splitType: 'Power', sType: '' },
        compareTo: { value: 'self' },
        thresholds: { warning: NaN, error: 0 },
        options: { lastPrevVsFuture: true },
      },
      {
        key: 'jbp-planning-check-fin-plan-split-power',
        order: 2,
        isEnabled: true,
        current: { value: 'fin', splitType: 'Power', sType: 't' },
        compareTo: { value: 'self' },
        thresholds: { warning: NaN, error: -1 },
        options: { lastPrevVsFuture: true },
      },
    ],
  },
  {
    // Disabled by flag: IS_CHECK_SELF_IN_FUTURE_FQ
    key: 'jbp-planning-check-fin-plan-zero-feature',
    rules: [
      {
        key: 'jbp-planning-check-fin-plan-zero-feature-fin',
        order: 1,
        isEnabled: false,
        current: { value: 'fin', type: 'targets', isFutureFq: true },
        compareTo: { value: 'self' },
        thresholds: { warning: NaN, error: 0 },
      },
      {
        key: 'jbp-planning-check-fin-plan-zero-feature-sob',
        order: 2,
        isEnabled: false,
        current: { value: 'sob', type: 'targets', isFutureFq: true },
        compareTo: { value: 'self' },
        thresholds: { warning: NaN, error: 0 },
      },
    ],
  },
  {
    // If Fin Plan or SOB plan is input as 0 - mandatory ask for justification
    key: 'jbp-planning-check-fin-plan-zero',
    rules: [
      {
        key: 'jbp-planning-check-fin-plan-zero-fin',
        order: 1,
        isEnabled: true,
        current: { value: 'fin', type: 'targets' },
        compareTo: { value: 'self' },
        thresholds: { warning: NaN, error: 0 },
      },
      {
        key: 'jbp-planning-check-fin-plan-zero-sob',
        order: 2,
        isEnabled: true,
        current: { value: 'sob', type: 'targets' },
        compareTo: { value: 'self' },
        thresholds: { warning: NaN, error: 0 },
      },
    ],
  },
  {
    key: 'jbp-planning-check-zero-plan-vs-actuals',
    rules: [
      {
        // Compare Fin Plan with (same FQ, same FY) Fin Actual
        key: 'jbp-planning-check-zero-plan-vs-actuals-fin',
        order: 1,
        isEnabled: true,
        current: { value: 'fin', type: 'targets', isZeroInput: true },
        compareTo: { value: 'fin', type: 'actuals' },
        thresholds: { warning: NaN, error: 0 },
      },
      {
        // Compare SOB Plan with (same FQ, same FY) SOB Actual
        key: 'jbp-planning-check-zero-plan-vs-actuals-sob',
        order: 1,
        isEnabled: true,
        current: { value: 'sob', type: 'targets', isZeroInput: true },
        compareTo: { value: 'sob', type: 'actuals' },
        thresholds: { warning: NaN, error: 0 },
      },
    ],
  },
  {
    // If SOB Actuals is input as 0 - ask for justification when fin actuals for the same period > 0
    key: 'jbp-planning-check-zero-actuals',
    rules: [
      {
        key: 'jbp-planning-check-zero-actuals-sob-vs-fin',
        order: 1,
        isEnabled: true,
        current: { value: 'sob', type: 'actuals', fy: 'prev', isZeroInput: true },
        compareTo: { value: 'fin', type: 'actuals', fy: 'prev' },
        thresholds: { warning: NaN, error: 1 },
      },
    ],
  },
]

export const IS_CHECK_SELF_IN_FUTURE_FQ = false
export const IS_CHECK_LAST_PREV_VS_FUTURE = false

export {
  OVERALL_CATEGORY_MANDATORY_FLAG,
  READONLY_FLAGS,
  TOP_PARTNER_FLAGS,
  MANDATORY_CATEGORY_VISIBLE_SUFFIX,
  MANDATORY_CATEGORY_CONTRACTUAL_SUFFIX,
} from 'partner360/entities/planning'
